import { render, staticRenderFns } from "./AdminCustomers.vue?vue&type=template&id=25a82043&scoped=true&"
import script from "./AdminCustomers.vue?vue&type=script&lang=js&"
export * from "./AdminCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a82043",
  null
  
)

export default component.exports